
import { DataMap } from 'src/classes';
import { cols, Props } from 'src/types';
import { buildChartCard } from '../../ChartCard/utils'

interface ChartCardItem {
    order: number,
    element: any
}

export const buildChartCards = (cols: cols, props: Props, data: DataMap[]) => {
  if(props.alerts) {
    const chartCardsArray: ChartCardItem[] = buildChartCardsArray(cols, props, data);
    if(props.sortOrder === "alerts") {
      return chartCardsArray.sort((a: ChartCardItem, b) => {
        return b.order - a.order;
      });
    } else {
      return chartCardsArray;
    }
  } else return [];
}

const buildChartCardsArray = (cols: cols, props: Props, data: DataMap[]): ChartCardItem[] => {
  return data.reduce((acc: ChartCardItem[], map: DataMap, index: number) => {
    if(map.monitor.checked) {
      const chartCard = buildChartCard(cols, map, props, index);
      acc.push(chartCard);
    }
    return acc;
  }, [])
}



// WEBPACK FOOTER //
// ./src/components/ChartPanel/utils/buildChartCards.tsx